var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.908,
    height: 96.908,
    viewBox: "0 0 96.908 96.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35",
    "data-name": "Layer 35",
    transform: "translate(-3.4 -3.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96268",
    "data-name": "Path 96268",
    d: "M51.854,3.4a48.454,48.454,0,1,0,48.454,48.454A48.437,48.437,0,0,0,51.854,3.4Zm0,83.354a7.319,7.319,0,1,1,7.3-7.3A7.319,7.319,0,0,1,51.854,86.754Zm8.861-60.313L57.953,63.713a1.017,1.017,0,0,1-1.017.949H46.771a1.017,1.017,0,0,1-1.017-.949L42.993,26.441a8.878,8.878,0,1,1,17.721,0Z",
    transform: "translate(0 0)",
    fill: "#ffc048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.79b2d837eea01db9380a9c12240e3161.svg";
export { ForwardRef as ReactComponent };